<template>
  <ag-input
    :id="id"
    ref="input"
    class="input"
    :value="value"
    :disabled="disabled"
    :readonly="readonly"
    :max-length="maxLength"
    autocomplete="off"
    @change="onChange"
  />
</template>

<script>
  export default {
    name: "NumberInput",
    props: {
      id: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: "text"
      },
      value: [Number, String],
      disabled: Boolean,
      readonly: Boolean,
      maxLength: Number
    },
    methods: {
      onChange(value) {
        const isNumber = value.match(/^[0-9]*$/);
        if (!isNumber) {
          this.$refs["input"].$forceUpdate();
          return;
        }

        this.$emit("change", value);
      }
    }
  };
</script>
